import React from 'react';
import { motion } from 'framer-motion';
export function ResultsTimeline() {
  const timeline = [{
    day: 'Día 1',
    title: 'Claridad Inmediata',
    desc: 'Déficit de $350 identificado (café +$20, comida -$10). Sabes exactamente dónde estás parada.',
    align: 'left'
  }, {
    day: 'Día 3',
    title: 'Primer Logro',
    desc: 'Deuda pequeña pagada ($140). El momentum gana y sientes que por fin tienes el control.',
    align: 'right'
  }, {
    day: 'Día 7',
    title: 'Paz Mental',
    desc: 'El gráfico muestra $100 en ahorro automático. Duermes tranquila sabiendo que hay un plan.',
    align: 'left'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-213">
            En 7 días verás esto:
          </h2>
        </motion.div>

        <div className="relative border-l-4 border-success/30 ml-4 md:mx-auto md:w-full md:border-l-0" data-id="element-214">
          {/* Center line for desktop */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-1 bg-success/30 -translate-x-1/2" data-id="element-215" />

          <div className="space-y-12" data-id="element-216">
            {timeline.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: item.align === 'left' ? -30 : 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} className={`relative flex flex-col md:flex-row items-center ${item.align === 'right' ? 'md:flex-row-reverse' : ''}`} data-id="element-217">
                {/* Timeline Dot */}
                <div className="absolute left-[-11px] md:left-1/2 w-6 h-6 bg-success rounded-full border-4 border-white md:-translate-x-1/2 z-10" data-id="element-218" />

                {/* Content Box */}
                <div className={`ml-8 md:ml-0 md:w-1/2 ${item.align === 'left' ? 'md:pr-12' : 'md:pl-12'} w-full`} data-id="element-219">
                  <div className="bg-cream p-6 rounded-2xl shadow-sm border border-success/10 hover:border-success/30 transition-colors" data-id="element-220">
                    <span className="inline-block px-3 py-1 bg-success/10 text-success font-bold rounded-full text-sm mb-3" data-id="element-221">
                      {item.day}
                    </span>
                    <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-222">
                      {item.title}
                    </h3>
                    <p className="text-charcoal/80" data-id="element-223">{item.desc}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 bg-purple-dark text-white p-8 rounded-3xl text-center max-w-2xl mx-auto shadow-xl relative" data-id="element-224">
          <div className="text-4xl text-gold absolute top-4 left-4 opacity-50" data-id="element-225">
            "
          </div>
          <p className="text-xl md:text-2xl font-heading italic relative z-10 mb-4" data-id="element-226">
            De $0 a $250 en mi fondo de emergencia en el primer mes.
          </p>
          <p className="text-cream/80 text-sm uppercase tracking-wider font-bold" data-id="element-227">
            — Una mamá que lo probó
          </p>
          <p className="mt-4 text-xs text-cream/50" data-id="element-228">
            Sin promesas mágicas, solo un sistema probado.
          </p>
        </motion.div>
      </div>
    </section>;
}